var _rect, _path, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 22,
    height: 22,
    rx: 11,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.25 7.49999C9.25 10.3995 11.6005 12.75 14.5 12.75C15.0304 12.75 15.5424 12.6715 16.0251 12.5253C15.3717 14.681 13.3691 16.2499 11 16.2499C8.1005 16.2499 5.75 13.8996 5.75 11.0001C5.75 8.63098 7.31921 6.62839 9.47494 5.97501C9.32865 6.45764 9.25 6.96959 9.25 7.49999Z",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_38_861)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.0001 6.33332V5.16666M11.0001 15.6667V16.8333M7.74171 7.74161L6.91675 6.91666M14.3414 14.3413L15.1664 15.1663M6.33341 11H5.16675M15.6667 11H16.8334M14.3417 7.74161L15.1667 6.91666M7.74199 14.3413L6.91703 15.1663M11.0001 13.9167C9.38925 13.9167 8.08341 12.6108 8.08341 11C8.08341 9.38916 9.38925 8.08332 11.0001 8.08332C12.6109 8.08332 13.9167 9.38916 13.9167 11C13.9167 12.6108 12.6109 13.9167 11.0001 13.9167Z",
    stroke: "#3A3A3A",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_38_861"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14,
    height: 14,
    fill: "white",
    transform: "translate(4 4)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLight);
export default __webpack_public_path__ + "static/media/light.2dbfe7a317e4cc21457dec930c8cdce1.svg";
export { ForwardRef as ReactComponent };